export default "__VITE_ASSET__d75feb47__"